module.exports = __webpack_public_path__ + "static/media/texpert-img3.d8e05a62.jpg";